import React from "react"

import Layout from "../../components/layout/Layout/Layout"
import Header from "../../components/layout/Header/Header"
import ForgotPassword from "../../components/layout/ForgotPassword/ForgotPassword"

export default function ForgotPasswordPage() {
  return (
    <Layout>
      <Header user={false} />
      <ForgotPassword />
    </Layout>
  );
}
